import { useTranslation } from 'react-i18next'
import { Button } from './ui/button'

const languages = [
  { code: 'en', name: 'EN' },
  { code: 'fr', name: 'FR' },
  { code: 'ar', name: 'ع' },
]

export function LanguageSwitcher() {
  const { i18n } = useTranslation()

  // A detected tag like `ar-TN` shows the Arabic UI, so match on the base tag
  // or no button would look selected.
  const activeLanguage = (i18n.language || 'en').split('-')[0]

  const changeLanguage = (langCode: string) => {
    i18n.changeLanguage(langCode)
  }

  return (
    // Pinned to a physical corner like the map controls, so the languages stay
    // in the same order whichever one is active.
    <div className="fixed bottom-4 left-4 z-50 flex gap-1" dir="ltr">
      {languages.map((lang) => (
        <Button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          variant={activeLanguage === lang.code ? 'default' : 'outline'}
          size="sm"
          className="min-w-[40px]"
        >
          {lang.name}
        </Button>
      ))}
    </div>
  )
}
